import './styles/Checker.scss';
import { Fragment } from 'react';

//mui icons
import Done from '@mui/icons-material/Done';
import Close from '@mui/icons-material/Close';

interface Props {
    label: string,
    checked: boolean, SetChecked: any,
    style?: any,
    boxDirection?: string, //top, bottom, left, right
    mode?: string, //tick, cross
    disabled?: boolean,
    OnCheckerClicked?: any,
}

const Checker: React.FC<Props> = ({ label, checked, SetChecked, style, boxDirection, mode, disabled, OnCheckerClicked }) => {

    //ui functions
    const OnCheckboxClicked = () => {
        SetChecked(!checked);

        if (OnCheckerClicked != undefined) {
            OnCheckerClicked();
        }
    }

    //render functions
    const RenderLeftBoxChecker = () => {
        return (
            <Fragment>
                <button className='Checker-checkbox Checker-box-style' onClick={() => OnCheckboxClicked()} disabled={disabled != undefined ? disabled : false}>
                    {
                        checked ?
                            (
                                (mode == undefined || mode == 'tick') ?
                                    <Done />
                                    :
                                    <Close />
                            )
                            :
                            null
                    }
                </button>
                <span className='Checker-lbl Checker-label-style'>{label}</span>
            </Fragment>
        )
    }
    const RenderRightBoxChecker = () => {
        return (
            <Fragment>
                <span className='Checker-lbl Checker-label-style'>{label}</span>
                <button className='Checker-checkbox Checker-box-style' onClick={() => OnCheckboxClicked()} disabled={disabled != undefined ? disabled : false}>
                    {
                        checked ?
                            (
                                (mode == undefined || mode == 'tick') ?
                                    <Done />
                                    :
                                    <Close />
                            )
                            :
                            null
                    }
                </button>
            </Fragment>
        )
    }

    return (
        <div className={'Checker'} style={style ? style : {}}>
            {
                boxDirection == undefined || boxDirection == 'left' ?
                    RenderLeftBoxChecker()
                    :
                    RenderRightBoxChecker()

            }
        </div>
    )
}
export default Checker;